export default __webpack_public_path__ + "static/media/kiosk-trans-new-booking-system-cv.9211b397.png";